import AspectRatio from '@mui/icons-material/AspectRatio';
import CloseIcon from '@mui/icons-material/Close';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Tab,
    Tabs,
    Tooltip,
    Typography
} from '@mui/material';
import AlertaInconsistenciaEmentaDecisao, { TIPO_TEXTO } from '@/components/certidao/AlertaInconsistenciaEmentaDecisao';
import ForcarAtualizacaoEmentaDecisao from '@/components/sessao/ForcarAtualizacaoEmentaDecisao';
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../../../css/processo.css';
import ReactComponent from '../../../ReactComponent';
import Decisao from './Decisao';
import Ementa from './Ementa';
class EmentaDecisao extends ReactComponent {
    dialogEmentaDecisao;
    openDialog = false;
    tabAtiva = 0;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogEmentaDecisao: observable,
            openDialog: observable,
            tabAtiva: observable,
            registro: computed,
            abrirDialogExpandirVisualizacao: action,
            handleCloseDialog: action,
            handleTab: action,
            renderAlertaInconsistenciaEmentaDecisao: computed
        });
    }

    componentDidMount() {
        this.salaSessaoStore.carregarEmentaDecisao(this.registro);
    }

    reactionRegistro = reaction(
        () => this.registro,
        () => {
            this.salaSessaoStore.carregarEmentaDecisao(this.registro);
        }
    );

    get registro() {
        return this.observableProps.registro;
    }

    abrirDialogExpandirVisualizacao = () => {
        switch (this.tabAtiva) {
            case 0:
                this.dialogEmentaDecisao = 'Decisão';
                this.openDialog = true;
                break;
            case 1:
                this.dialogEmentaDecisao = 'Ementa';
                this.openDialog = true;
                break;
            case 2:
                this.dialogEmentaDecisao = 'Observação do gabinete';
                this.openDialog = true;
                break;
            default:
                break;
        }
    };

    handleCloseDialog = () => {
        this.openDialog = false;
    };

    handleTab = (tab) => {
        if (tab !== this.tabAtiva) {
            this.tabAtiva = tab;
        }
    };

    get estiloAbas() {
        return {
            bgcolor: 'background.paper',
            minHeight: '36px',
            minWidth: '140px'
        };
    }

    renderDialogContent(maxHeight) {
        switch (this.dialogEmentaDecisao) {
            case 'Ementa':
                return (
                    <Ementa
                        registro={this.registro}
                        maxHeight={maxHeight}
                    />
                );
            case 'Decisão':
                return (
                    <Decisao
                        registro={this.registro}
                        maxHeight={maxHeight}
                    />
                );
            case 'Observação do gabinete':
                return (
                    <div style={{ display: 'flex', maxHeight: maxHeight }}>
                        <span
                            data-sentry-mask
                            style={{ color: 'black' }}
                            dangerouslySetInnerHTML={{ __html: this.registro.observacaoGabinete }}
                        ></span>
                    </div>
                );
            default:
                break;
        }
    }

    get renderAlertaInconsistenciaEmentaDecisao() {
        if (![0, 1].includes(this.tabAtiva)) {
            return <></>;
        }

        const texto = this.tabAtiva === 0 ? TIPO_TEXTO.DECISAO : TIPO_TEXTO.EMENTA;

        return (
            <AlertaInconsistenciaEmentaDecisao
                registro={this.registro}
                tipoTexto={texto}
            />
        );
    }

    render() {
        return (
            <>
                <Tabs
                    orientation="horizontal"
                    variant="scrollable"
                    value={this.tabAtiva}
                    sx={this.estiloAbas}
                    textColor="primary"
                    indicatorColor="primary"
                >
                    <Tab
                        label="Decisão"
                        onClick={() => this.handleTab(0)}
                        sx={this.estiloAbas}
                    />
                    <Tab
                        label="Ementa"
                        onClick={() => this.handleTab(1)}
                        sx={this.estiloAbas}
                    />
                    {this.registro.observacaoGabinete && (
                        <Tab
                            label="Observação"
                            onClick={() => this.handleTab(2)}
                            sx={this.estiloAbas}
                        />
                    )}
                    <Box sx={{ cursor: 'pointer', pt: 0.5, pl: 1 }}>
                        <Tooltip title={<Typography>{'Expandir visualização'}</Typography>}>
                            <span>
                                <IconButton onClick={this.abrirDialogExpandirVisualizacao}>
                                    <AspectRatio sx={{ color: 'black' }} />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                    <Box sx={{ cursor: 'pointer', pt: 0.5 }}>
                        <ForcarAtualizacaoEmentaDecisao registro={this.registro} />
                    </Box>
                </Tabs>
                <div
                    style={{
                        display: 'flex',
                        flexGrow: 1,
                        overflowY: 'scroll',
                        boxSizing: 'border-box',
                        borderColor: 'rgba(0, 0, 0, 0.23)',
                        borderStyle: 'solid',
                        borderWidth: '1px',
                        borderRadius: '4px',
                        padding: '8px 13px',
                        lineHeight: '1.5em'
                    }}
                >
                    {this.tabAtiva === 0 && (
                        <Decisao
                            registro={this.registro}
                            maxHeight={'5vh'}
                            minHeight={'5vh'}
                        />
                    )}
                    {this.tabAtiva === 1 && (
                        <Ementa
                            registro={this.registro}
                            maxHeight={'5vh'}
                            minHeight={'5vh'}
                        />
                    )}
                    {this.tabAtiva === 2 && (
                        <div
                            style={{ display: 'flex', maxHeight: '80px', minHeight: '80px', fontFamily: 'sans-serif' }}
                        >
                            <span
                                data-sentry-mask
                                style={{ color: 'black' }}
                                dangerouslySetInnerHTML={{ __html: this.registro.observacaoGabinete }}
                            ></span>
                        </div>
                    )}
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '0px 0px 5px 5px' }}>
                    <Dialog
                        open={this.openDialog}
                        onClose={this.handleCloseDialog}
                        maxWidth="lg"
                        style={{ minHeight: '400px' }}
                    >
                        <DialogTitle>{this.dialogEmentaDecisao}</DialogTitle>
                        <DialogContent>{this.renderDialogContent('80%')}</DialogContent>
                        <DialogActions sx={{ pr: 3, pb: 1 }}>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="primary"
                                variant="contained"
                                endIcon={<CloseIcon />}
                            >
                                Fechar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </>
        );
    }
}

export default inject('stores')(observer(EmentaDecisao));
